import axios from "axios";
import { csvParse } from "d3-dsv";

function formatWordCase(word) {
  word = word.trim();
  if (!word) return " ";
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
}

function firstSentenceText(text) {
  const re = /\n/;
  return text.slice(0, text.search(re));
}

export default async function importData(dataUrl) {
  return axios.get(dataUrl, { responseType: "text" }).then(response => {
    const allPoems = csvParse(response.data).map(d =>
      Object.assign({}, d, {
        themes: d.Thema.split(", ").map(formatWordCase),
        moods: d.Stimmung.split(", ").map(formatWordCase),
        motifs: d.Motive.split(", ").map(formatWordCase),
        year: (() => {
          const dateSplitted = d.Zeit.split(".");
          if (dateSplitted.length === 1) {
            // Year
            return +dateSplitted[0];
          } else if (dateSplitted.length === 2) {
            // Month/Year
            return +dateSplitted[1];
          } else if (dateSplitted.length === 3) {
            // Day/Month/Year
            return +dateSplitted[2];
          }
        })(),
        firstSentence: firstSentenceText(d["Gedicht (Text)"])
      })
    );
    const poems = allPoems.filter(d => d.year).map(d => Object.freeze(d));
    return poems;
  });
}
